import React from 'react';

import Button from 'shared/button';
import { buildGrantUrl } from './helpers';

import type { Grant, Provider } from '../types';

interface Props {
  grant?: Grant;
  path: string;
  provider: Provider;
  scopes?: string[];
}

export default function ConnectNylasGrant({ grant, path, provider, scopes }: Props) {
  return (
    <Button.Accent
      className="gap-2"
      outlined
      onClick={() => window.location.assign(buildGrantUrl(path, scopes))}
    >
      <img src={provider.ssoIcon || provider.icon} style={{ width: 16, height: 16 }} />
      {grant ? 'Reconnect' : 'Connect'} with {provider.ssoLabel || provider.label}
    </Button.Accent>
  );
}
